module.exports = __webpack_public_path__ + "img/SLT_5919-Bearbeitet.d4402017.jpg";